const config = {
  showReferralMidwife: false,
  showMidwife: true,
  showMeSignUp: false,
  showQmMidwife: true,
}

export default config
